import * as Yup from 'yup'
export default Yup.object({
    username: Yup.string().required("Username is a required field"),
    name: Yup.string().required("Name is required"),
    password: Yup.string().min(8, "Password mas contain 8 or more chars").required('Password is required'),
    confirmPass: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
});
